var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.initialized)?_c('Publisher',{ref:"publisher",attrs:{"isSysCheck":_vm.isSysCheck,"isBreakout":_vm.isBreakout,"mediaOnly":_vm.mediaOnly,"token":_vm.activeToken},on:{"publishError":function($event){return _vm.$emit('publishError', $event)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }